<style scoped lang="scss" type="text/scss">
    .nameplate-container {
        width: 6rem;
        height: 1.5rem;
        border-radius: .15rem;
        background-color: #3F7EFF;
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .8rem;
        color: #FFF;

        span {
            margin-left: .5rem;
            text-align: center;
            font-weight: bold;
        }
    }
</style>

<template>
    <div class="nameplate-container">
        <i class="icon" v-html="icon"></i>
        <span>{{ text }}</span>
    </div>
</template>

<script>
    import {ROLE_VALUE_MAP} from '../../constant/role';

    export default {
        name: '',
        props: {
            role: {
                type: Number | String,
                default: ''
            }
        },
        data () {
            return {
                icon: '',
                text: ''
            };
        },
        watch: {
            role: {
                immediate: true,
                handler (role) {
                    if (role === ROLE_VALUE_MAP.STUDENT) {
                        this.assign('&#xe600;', '学生');
                    } else if (role === ROLE_VALUE_MAP.TEACHER) {
                        this.assign('&#xe68b;', '教师');
                    } else if (role === ROLE_VALUE_MAP.FAN) {
                        this.assign('&#xe62c;', '爱好者');
                    } else if (role === ROLE_VALUE_MAP.ADMIN) {
                        this.assign('&#xe613;', '管理员');
                    } else if (role === ROLE_VALUE_MAP.ADMIN_READ_ONLY) {
                        this.assign('&#xe613;', '基础管理员');
                    } else {
                        this.assign('&#xe670;', '游客');
                    }
                }
            }
        },
        methods: {
            assign (icon, text) {
                this.icon = icon;
                this.text = text;
            }
        }
    };
</script>
